import React from 'react';
import cx from 'classnames';

import Text from '../Text';

import { useNavContext } from './NavigationContext';

import { getInitials } from './helpers';
import styles from './NavigationAvatar.module.scss';

export interface NavigationAvatarProps {
  /** Apply CSS class to the container. */
  className?: Parameters<typeof cx>[0];
  /** If `true`, it will display its collapse state. */
  isCollapsed?: boolean;
  /** The name of the account user. */
  name: string;
  /** The url for the avatar image. If `undefined`, will display the full name initials. */
  src?: string;
}

export const NavigationAvatar: React.FC<NavigationAvatarProps> = ({
  className,
  name,
}) => {
  const { isCollapsed } = useNavContext();

  return (
    <div className={cx(styles.avatarGroup, className)}>
      <div className={cx(styles.avatar)}>
        <Text
          size={12}
          as='span'
          weight='extraBold'
          contrast='inverse-high'
          className={styles.initials}
        >
          {getInitials(name)}
        </Text>
      </div>
      {!isCollapsed && <div>{name}</div>}
    </div>
  );
};

export default NavigationAvatar;
export { styles };
